import { createSelector } from '@ngrx/store';
import * as fromFeature from '../reducers';
import * as fromBreadcrumbs from '../reducers/router-breadcrumbs.reducers';

export const getRouterFeatureState = createSelector(
  fromFeature.getRouterState,
  (state: fromFeature.RouterState) => state.routerBreadcrumbs
);

export const getBreadcrumbList = createSelector(getRouterFeatureState, fromBreadcrumbs.getBreadCrumbs);
